import { BASE_URLS, ENVIRONMENT_MODE } from "../../../../config/constants";
import { AxiosResponse } from "axios";
import axios from "../../../../config/axiosInterceptor";
import { RcFile } from "antd/es/upload";
import { CreateServiceLineType, CreateServiceType } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const uploadUserImage = async ({
  owner_id,
  image,
  image_type,
}: {
  owner_id: string;
  image: RcFile | File;
  image_type: string;
}): Promise<AxiosResponse<void>> => {
  const formData = new FormData();
  formData.append("owner_id", owner_id);
  formData.append("image", image);
  formData.append("image_type", image_type);
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios.post(`${baseURL}uploadUserImage`, formData, config);
};

export const createServiceLine = (
  payload: CreateServiceLineType
): Promise<AxiosResponse<CreateServiceLineType>> => {
  return axios.post(`${baseURL}createServiceLine`, payload);
};

export const deleteServiceLine = (
  serviceLineIds: string[] | React.Key[]
): Promise<AxiosResponse<string>> => {
  return axios.delete(`${baseURL}deleteServiceLine`, { data: serviceLineIds });
};

export const createService = (
  payload: CreateServiceType
): Promise<AxiosResponse<CreateServiceType>> => {
  return axios.post(`${baseURL}createService`, payload);
};

export const deleteService = (
  serviceIds: string[] | React.Key[]
): Promise<AxiosResponse<string>> => {
  return axios.delete(`${baseURL}deleteService`, { data: serviceIds });
};

export const changeServiceType = (payload: {
  service_id: string;
  type: string;
}): Promise<AxiosResponse<string>> => {
  return axios.post(`${baseURL}changeServiceType`, payload);
};

export const updateServiceStatus = (
  id: string,
  payload: {
    status: string;
  }
): Promise<AxiosResponse<string>> => {
  return axios.patch(`${baseURL}updateServiceStatus/${id}`, payload);
};

export const updateServiceLine = (
  id: string,
  payload: CreateServiceLineType
): Promise<AxiosResponse<string>> => {
  return axios.patch(`${baseURL}updateServiceLine/${id}`, payload);
};

export const updateServiceLineStatus = (
  id: string,
  payload: {
    status: string;
  }
): Promise<AxiosResponse<string>> => {
  return axios.patch(`${baseURL}updateServiceLineStatus/${id}`, payload);
};

export const updateService = (
  id: string,
  payload: CreateServiceType
): Promise<AxiosResponse<string>> => {
  return axios.patch(`${baseURL}updateService/${id}`, payload);
};
